import React from 'react'

import { useTranslation } from 'react-i18next'
import { useLocation } from 'react-router-dom'

import { PageStatus, usePageApi } from '@providers/PageApiProvider'
import { formatCommas } from '@utils/formatters/number.formatter'
import PageRoutes from '@utils/page-routes'

import type { SearchPageApiResponse } from '@providers/types/api-responses'

const ResultsCount: React.FC = () => {
  const { pageData, status } = usePageApi<SearchPageApiResponse>()
  const { t } = useTranslation()
  const location = useLocation()

  const count = pageData?.count

  if (count) {
    const isSearch = location.pathname.startsWith(PageRoutes.musicSearchPath())
    return (
      <p>
        {t(isSearch ? 'content.resultsFound' : 'content.filterTitles', {
          count,
          value: formatCommas(count),
        })}
      </p>
    )
  }

  if (status !== PageStatus.LOADED) {
    return <p>{t('action.searching')}...</p>
  }
  return <p>{t('content.noResults')}</p>
}

export default ResultsCount
